// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyRecommendationsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations,
  RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  GetRecommendationsRequestWebDto,
  GetRecommendationsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_Options = UseQueryOptions<
  GetRecommendationsResponseWebDto,
  unknown,
  GetRecommendationsResponseWebDto,
  readonly [string, GetRecommendationsRequestWebDto]
>;

const RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_GetKey = (
  postData: GetRecommendationsRequestWebDto,
) => [RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_Path, postData] as const;

export const RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_queryOptions = (
  postData: GetRecommendationsRequestWebDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_GetKey(postData),
    queryFn: () => RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listing recommendations for web clients.
 */
export const useRentalManagerUserPropertyRecommendationsWebApiHandler_recommendations = (
  postData: GetRecommendationsRequestWebDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyRecommendationsWebApiHandler_recommendations.getKey =
  RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_GetKey;
